import {WithTags} from "layout/Templates/WithTags";
import React, {useState, useEffect} from "react";
import "./index.css";
import cn from "classnames";
import Textarea from "../../../layout/Textarea/Textarea";
import ImageUpload from "../../../layout/ImageUpload/index";
import {UI, newsletterLayoutTypes, PLACEHOLDERS} from "../../../data/constants";
import {isDotNetToolsProduct} from "../../../libs/utils";
import {checkIfIDE} from "../../../data/products/index";
import {checkProductInText} from "../../../libs/utils";
import Icon from "../../../layout/Icon";
import ContentEditable from "../../../layout/ContentEditable/ContentEditable";
import BgTransformer from "../../../layout/BgTransformer";
import PixelationLayer from "../../../layout/PixelationLayer";
import {useSetting} from "../../../contexts/setting";
import {useEdits} from "../../../contexts/edits";
import {useBgUrl} from "hooks/useBgUrl";
import {useLogoUrl} from "../../../hooks/useLogoUrl";

const WebpagePreview = ({id, zoom}) => {
  const {product, layoutOption, type, channel} = useSetting();
  const {url: bgUrl} = useBgUrl();
  const {subtitles3, productNames} = useEdits();
  const logoURL = useLogoUrl(id);
  const subtitle3 = subtitles3?.[id] ?? subtitles3?.main ?? PLACEHOLDERS.en.subtitle3;
  const productName = productNames[id] || productNames.main || product.shortLabel || product.label;

  const isNewsletter = newsletterLayoutTypes.includes(type.value);
  const showProductName =
    !isDotNetToolsProduct(product.value) &&
    !checkProductInText(productName, subtitle3) &&
    !checkProductInText(product.label, subtitle3);
  const newsletterClass = isNewsletter ? "newsletter" : "";
  const templateClass = cn("template", product.value, `layout-${layoutOption}`, newsletterClass);
  const logoClass = cn("logo", {ide: checkIfIDE(product.value)});

  return (
    <>
      <div id={id} className={templateClass} style={{"--zoom-level": zoom}}>
        <div>
          <BgTransformer src={bgUrl} id={id} />
          <PixelationLayer />

          <div className="content">
            <header className="template-header">
              <div className={logoClass}>
                <img src={logoURL} alt="background" />
              </div>
              {showProductName && (
                <div className="product-name">
                  <ContentEditable id={id} text={productName} />
                </div>
              )}
            </header>

            <div className="title-wrap">
              <h1 className="subtitle3">
                <Textarea id={id} text={subtitle3} />
              </h1>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WebpagePreview;
